import { Progress } from 'element-ui'

const YProgress = Progress
YProgress.$depends = [Progress]
YProgress.$name = 'y-progress'
YProgress._name = 'Progress 进度条'

export default YProgress
